module.exports = __webpack_public_path__ + "img/anli2@2X.62c97d2f.png";